/**
 * gallery-slider.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Arrow navigation for the horizontal gallery slider: prev/next scroll the
 * track item by item (smooth, respecting the content start line). Native
 * swipe/scroll keeps working — the buttons are a convenience on top.
 */

(() => {
  "use strict";

  function initSlider(root) {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = "true";

    var track = root.querySelector("[data-slider-track]");
    if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll("[data-slider-item]"));
    if (!items.length) return;

    // The snap origin: distance from track edge to the content grid line.
    function startOffset() {
      return items[0] ? items[0].offsetLeft : 0;
    }

    function currentIndex() {
      var pos = track.scrollLeft + startOffset();
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.offsetLeft - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function goTo(index) {
      var clamped = Math.max(0, Math.min(items.length - 1, index));
      track.scrollTo({
        left: items[clamped].offsetLeft - startOffset(),
        behavior: "smooth",
      });
    }

    root.querySelector("[data-slider-prev]").addEventListener("click", function () {
      goTo(currentIndex() - 1);
    });
    root.querySelector("[data-slider-next]").addEventListener("click", function () {
      goTo(currentIndex() + 1);
    });
  }

  function initAll(scope) {
    scope.querySelectorAll("[data-gallery-slider]").forEach(initSlider);
  }

  initAll(document);

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
